import { ReduxState } from '../../store'

export const selectCurrency = (state: ReduxState) => state.appSettings.currency
export const selectMinimumWithdrawalAmountCents = (state: ReduxState) =>
  state.appSettings.minimumWithdrawalAmountCents
export const selectFixedWithdrawalFeeCents = (state: ReduxState) =>
  state.appSettings.fixedWithdrawalFeeCents
